import { IndustryPageTemplate } from "@/components/templates/IndustryPageTemplate";
import { geoCluster, getRelatedMoneyPages, getRelatedInsightPages } from "@/data/contentClusters";

const pageData = geoCluster.industryPages.find(p => p.slug === "seo-saas-companies")!;
const relatedMoney = getRelatedMoneyPages("geo").map(p => ({ title: p.title, slug: p.slug, pillarSlug: p.pillarSlug }));
const relatedInsights = getRelatedInsightPages("geo").map(p => ({ title: p.title, slug: p.slug }));

export default function SEOSaaSCompaniesPage() {
  return (
    <IndustryPageTemplate
      page={pageData}
      relatedMoneyPages={relatedMoney}
      relatedInsightPages={relatedInsights}
    />
  );
}
